<template>
  <v-app class="bg-color">
    <v-main>
      <v-layout row wrap justify-center align-center pt-7>
        <v-flex xs11 lg11>
          <h2>
            <v-icon color="#077893" @click="Fn_BackIndex" size="38"
              >mdi-chevron-left</v-icon
            >{{ $t("template.text9") }}
          </h2>
        </v-flex>
      </v-layout>
      <v-container grid-list-lg fluid class="pb-10 pt-3">
        <v-layout row wrap justify-center align-start>
          <v-flex lg8 md8 xs11 sm11 pt-5 pb-2>
            <v-card class="mx-auto rounded-lg">
              <v-card-text class="black--text">

              <v-form ref="form" lazy-validation>
                <v-layout row wrap justify-left align-left pt-3>
                  <v-flex lg2 xs12 pl-4>
                    <b>{{ $t("template.text4") }} :</b>
                  </v-flex>
                  <v-flex lg9 xs12>
                    <v-text-field
                      v-model="NameTemplate"
                      :label="$t('template.text4')"
                      :rules="[
                        (v) => !!v || $t('template.text5') + ' Template',
                      ]"
                      outlined
                      dense
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              <v-layout row wrap justify-left align-left>
                <v-flex lg2 xs12 pl-4>
                  <b>{{ $t("template.text6") }} :</b>
                </v-flex>
                <v-flex lg9 xs12>
                  <v-text-field
                    v-model="SubjectEmail"
                    :label="$t('template.text6')"
                    outlined
                    dense
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap justify-left align-left>
                <v-flex lg11 xs12 pl-4>
                  <b>{{ $t("template.text7") }} : </b>
                </v-flex>
              </v-layout>
              <v-layout row wrap justify-center align-center>
                <v-flex lg11 xs12 pl-4 pr-4 pb-2>
                  <v-card-text style="margin-top: -2%">
                    <v-tabs color="#077893" v-model="tab">
                      <v-tab> Editor </v-tab>
                      <v-tab> Html code </v-tab>
                      <!-- tab editor -->
                      <v-tab-item>
                        <vue-editor
                          v-model="Content"
                          :editorToolbar="DefaultToolbar"
                        />
                      </v-tab-item>
                      <!-- tab html code -->
                      <v-tab-item>
                        <v-textarea
                          dark
                          outlined
                          auto-grow
                          no-resize
                          background-color="#077893"
                          row-height="50"
                          v-model="HtmlCode"
                          color="white"
                        ></v-textarea>
                      </v-tab-item>
                    </v-tabs>
                  </v-card-text>
                  <br />
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <!-- <v-chip v-if="valSelect === ''" class="ma-2" color="red" text-color="white">
                      <v-icon left small> mdi-close </v-icon>
                      {{ $t("template.text21") }}
                    </v-chip>
                    <v-chip v-else class="ma-2" color="success" text-color="white">
                      <v-icon left> mdi-check </v-icon>
                      {{ $t("template.text22") }}
                    </v-chip> -->
                    <v-btn
                      @click="Fn_Save"
                      color="#077893"
                      class="ma-2 white--text"
                      >{{ $t("template.text10") }}</v-btn
                    >
                    <v-btn
                      color="#077893"
                      outlined
                      class="ma-2"
                      @click="fn_openTemplateEmailTest"
                    >
                      {{ $t("template.text15") }}</v-btn
                    >
                    <v-btn to="/email-template-index" outlined color="error">
                      <v-icon left> mdi-close-circle-outline </v-icon
                      >{{ $t("smtp.text11") }}
                    </v-btn>
                  </v-card-actions>
                </v-flex>
              </v-layout>
            </v-form>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex lg3 md3 xs11 sm11 pl-4 pr-4 pt-5 pb-2>
            <DialogSelector @fn_selector="Fn_Selector" @test_check="test_check">
            </DialogSelector>
          </v-flex>
        </v-layout>
      </v-container>
      <DialogTemplateEmailTest
        :show="DialogTemplateEmailTest"
        :_SubjectEmail="SubjectEmail"
        :_Content="EncodeHtml"
        :_NameTemplate="NameTemplate"
        @closeDialogTemplateEmailTest="DialogTemplateEmailTest = false"
      />
    </v-main>
  </v-app>
</template>

<script>
import DialogTemplateEmailTest from "@/components/dialog/DialogTemplateEmailTest";
import authorization from "@/functions/authorization.js";
import DialogSelector from "@/views/Admin/Email/TemplateEmail/TemplteEmailAddRight.vue";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import { VueEditor } from "vue2-editor";
import { mapGetters } from "vuex";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: {
    VueEditor,
    DialogTemplateEmailTest,
    DialogSelector,
  },
  data: function () {
    return {
      tab: 0,
      Content: "",
      Test: "",
      showTestsendMail: false,
      DialogTemplateEmailTest: false,
      HtmlCode: "",
      EncodeHtml: "",
      NameTemplate: "",
      SubjectEmail: "",
      item_select: "",
      TemplateId: "",
      rowradio: null,
      DefaultToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
        [{ color: [] }, { size: 56 }, { background: [] }],
      ],
      HtmlHead: `<html><head>
                <style>.space {white-space: pre;}   
                        p {margin: 0px;}
                        .ql-align-left {
                          text-align: left;
                        }
                        .ql-align-center {
                          text-align: center;
                        }
                        .ql-align-right {
                          text-align: right;
                        }</style>
                </head><body><div class='space'>`,
      HtmlTail: "</div></body></html>",
      valSelect: "",
      check: "",
      disabled: false,
      DisabledSave: true,
    };
  },
  computed: {
    ...mapGetters(["RoleAccount"]),

    _RoleAccount: {
      get() {
        return this.RoleAccount || "-";
      },
    },
    CheckTab: {
      get() {
        if (this.tab === 1) {
          return true;
        } else {
          return false;
        }
      },
    },
  },
  mounted() {
    this.Fn_GetData();
    if (this.valSelect === "") {
      this.DisabledSave = true;
    } else {
      this.DisabledSave = false;
    }
  },
  methods: {
    async Fn_GetData() {
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        TemplateId: this.$route.query.id,
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "config-notify/GetTemplateEmailById",
          { Data: dataEncode },
          { headers }
        )
        .then((res) => {
          if (res.data.Status === "OK") {
            if (res.data.Message[0].BusinessId === "Admin-CMP") {
              this.NameTemplate = res.data.Message[1].NameTemplate;
              this.SubjectEmail = res.data.Message[1].SubjectEmail;
              this.TemplateId = res.data.Message[1].TemplateId;
              this.HtmlCustom = res.data.Message[1].HtmlCustom;
              this.HtmlCode = res.data.Message[1].HtmlEmail;
              this.Content = res.data.Message[1].HtmlEdit;
            } else {
              this.NameTemplate = res.data.Message[0].NameTemplate;
              this.SubjectEmail = res.data.Message[0].SubjectEmail;
              this.TemplateId = res.data.Message[0].TemplateId;
              this.HtmlCustom = res.data.Message[0].HtmlCustom;
              this.HtmlCode = res.data.Message[0].HtmlEmail;
              this.Content = res.data.Message[0].HtmlEdit;
            }
            if (this.HtmlCustom === true) {
              this.HtmlCode = this.HtmlCode;
              this.tab = 1;
            } else {
              this.Content = this.Content;
              this.tab = 0;
            }
          } else {
            Toast.fire({
              icon: "error",
              title: "' " + res.data.ErrorMessage + " '",
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_Save() {
      if (this.$refs.form.validate()) {
        this.DisabledSave = false;
        var payload = {
          AccountId: this.$cookies.get("OneAccountId"),
          TemplateId: this.TemplateId,
          SubjectEmail: this.SubjectEmail,
          NameTemplate: this.NameTemplate,
          HtmlEmail: this.HtmlCode || ' ',
          HtmlEdit: this.Content || ' ',
          HtmlCustom: this.CheckTab,
        };
        var Headers = {
          AccountId: this.$cookies.get("OneAccountId"),
        };
        var dataEncode = await authorization.encodeDataNew(payload);
        var auth = await authorization.encodeDataNew(Headers);
        var headers = { Authorization: "Bearer " + auth };
        this.axios
          .post(
            process.env.VUE_APP_API_FACTORING_SERVICE +
              "config-notify/UpdateDetailTemplateEmail",
            { Data: dataEncode },
            { headers }
          )
          .then((res) => {
            this.DisabledSave = false;
            if (res.data.Status === "OK") {
              Toast.fire({
                icon: "success",
                title: this.$i18n.t("alert.tem"),
              });
              this.$router.push("/email-template-index");
            } else {
              Toast.fire({
                icon: "error",
                title: "' " + res.data.ErrorMessage + " '",
              });
            }
          })
          .catch((error) => {
            this.DisabledSave = false;
            if (error.response) {
              Toast.fire({
                icon: "error",
                title: error.response.data.ErrorMessage,
              });
            } else if (error.request) {
              Toast.fire({
                icon: "error",
                title: error.request,
              });
            } else {
              Toast.fire({
                icon: "error",
                title: error.message || error,
              });
            }
          });
      }
    },
    Fn_BackIndex() {
      this.$router.push("/email-template-index");
    },
    fn_openTemplateEmailTest() {
      if (this.tab === 0) {
        this.EncodeHtml = this.HtmlHead + this.Content + this.HtmlTail;
      } else {
        this.EncodeHtml = this.HtmlCode;
      }
      this.DialogTemplateEmailTest = true;
    },
    Fn_Selector(val) {
      if (val.content == "body") {
        if (this.tab == 0) {
          this.Content = this.Content + val.key;
        } else {
          this.HtmlCode = this.HtmlCode + val.key;
        }
      } else {
        this.SubjectEmail = this.SubjectEmail + val.key;
      }
    },
    test_check(val) {
      if (val.content == "body") {
        if (this.tab == 0) {
          this.Content = this.Content + val.key;
        } else {
          this.HtmlCode = this.HtmlCode + val.key;
        }
      } else {
        this.SubjectEmail = this.SubjectEmail + val.key;
      }
      this.valSelect = val.key;
      if (this.valSelect === "") {
        this.disabled = true;
      } else {
        this.disabled = false;
      }
    },
  },
  watch: {
    Content(val) {
      if (this.Content.includes("{{ButtonCheck}}") === true) {
        this.DisabledSave = false;
      } else {
        this.valSelect = "";
        this.DisabledSave = true;
      }
    },
  },
};
</script>

<style scoped>
.special-text {
  /* background-color: rgb(9, 53, 73); */
  border: 2px solid rgb(9, 53, 73);
  width: 250px;
  height: 100px;
  display: flex;
  color: black;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
}

.bg-color {
  background-color: #ddf7ff;
}
</style>
